import BuildCircleIcon from '@mui/icons-material/BuildCircle'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import IncompleteCircleIcon from '@mui/icons-material/IncompleteCircle'

import { theme } from '../themes/theme'

const attachmentStatusTypeMap = {
  DRAFTING: { type: 'drafting', label: 'Drafting', color: theme.colors.text.body, icon: <BuildCircleIcon /> },
  AWAITING_APPROVAL: { type: 'awaitingApproval', label: 'Awaiting Approval', color: '#D0C610', icon: <IncompleteCircleIcon /> },
  READY_TO_SEND: { type: 'readyToSend', label: 'Ready to Send', color: '#10D070', icon: <CheckCircleIcon /> }
}

const attachmentStatuses = Object.keys(attachmentStatusTypeMap)

const attachmentStatusDropdownOptions = attachmentStatuses.map(status => ({
  icon: attachmentStatusTypeMap[status].icon,
  label: attachmentStatusTypeMap[status].label,
  color: attachmentStatusTypeMap[status].color,
  value: status
}))

function formatAttachmentStatusDropdownOptions() {
  return attachmentStatuses.map(status => ({
    label: attachmentStatusTypeMap[status].label,
    value: status
  }))
}

export { attachmentStatusTypeMap, attachmentStatuses, attachmentStatusDropdownOptions, formatAttachmentStatusDropdownOptions }
